import { useTranslation } from "react-i18next";
import React from "react";
import { deleteHomePageCategoryLink } from "../../../../../../../axios/api/services";
import { toast } from "react-toastify";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../../hooks/redux/base/useAppSelector";
import { homePageCategorySection } from "../../../../../../../utils/constants";
import { closeDeleteModal } from "../../../../../../../store/redux/slice/ComponentsControl/homePageCategoryControl";
import { addCategoryViewObject } from "../../HomePageCategoryManagement";

const DeleteCategoryLinkDialog = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.homePageCategoryControl.sections[homePageCategorySection.link].modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeDeleteModal({ section: homePageCategorySection.link }));
  };

  const onSuccess = (response) => {
    addCategoryViewObject(response, dispatch);
    handleCloseDialog();
    toast.success(t("m.save.data.success"));
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteHomePageCategoryLink(id)}
      onSuccess={onSuccess}
      title={"t.homePage.category.link.delete.dialog"}
      message={"m.delete.homePage.category.link.warning.message"}
    />
  );
};

export default DeleteCategoryLinkDialog;
